export var chatMessageDetailsStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      marginLeft: v.detailsMargin,
      fontSize: v.detailsFontSize,
      display: 'inline-block',
      color: v.detailsColor,
      ':hover': {
        color: v.detailsHoverColor
      }
    }, p.mine && {
      color: v.detailsColorMine,
      ':hover': {
        color: v.detailsHoverColorMine
      }
    });
  }
};
//# sourceMappingURL=chatMessageDetailsStyles.js.map
